import styled from 'styled-components';

import { SCORE_CHIP_BACKGROUND } from '../styles';

export const InformationLine = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	line-height: 1.5rem;
	word-break: break-word;
`;

export const InformationLabel = styled.span`
	font-weight: 600;
`;

export const ScoresColumn = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100%;
`;

export const ScoreLabel = styled.span`
	display: inline-block;
	width: 7.1875rem;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5rem;
`;

export const ScoreChip = styled.span`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 1.5rem;
	height: 1.5rem;
	background: ${SCORE_CHIP_BACKGROUND};
	border: 1px solid ${({ theme }) => theme.palette.primary[600]};
	border-radius: 0.25rem;
	color: ${({ theme }) => theme.palette.primary[600]};
	font-size: 1rem;
	font-weight: 600;
	line-height: 1.5rem;
`;

export const RpnLabel = styled.span`
	display: inline-block;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1.25rem;
	font-weight: 600;
	line-height: 2rem;
	letter-spacing: -0.00625rem;
`;

export const RpnChip = styled(ScoreChip)`
	width: 3.125rem;
	height: 2.5rem;
`;
